export default __webpack_public_path__ + "static/media/businessimage.877479a1.jpg";